import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api/menuitem';
import { Profiles } from 'src/app/utils/enums/profiles';
import { CustomMenuBarService } from '../../services/custom-menu-bar.service';
import { IUser } from '../../interfaces/user.interface';
import { DataService } from '../../services/data.service';
import { IData } from '../../interfaces/data.interface';
import { DataValues } from 'src/app/utils/enums/data-values';

@Component({
  selector: 'custom-menu-bar',
  templateUrl: './custom-menu-bar.component.html',
  styleUrls: ['./custom-menu-bar.component.css']
})
export class CustomMenuBarComponent implements OnInit {
  constructor(
    private readonly _router: Router,
    private readonly _menuBarService : CustomMenuBarService,
    private readonly _dataService: DataService
  ){}
  menu: MenuItem[] = [];
  menuUser: MenuItem[] = [];
  profile?: string;
  user: IUser = {
    name: '', lastName: ''
  };
  primaryColorHexadecimal: string = '';
  secondaryColorHexadecimal: string = '';
  dataInfo: IData[] = [];
  isLoading: boolean = false;
  whatsAppNumber: string = '';
  whatsAppMessage: string = '';

  ngOnInit(): void {
    this.profile = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!).profile : Profiles.ADMIN
    this.user.name = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!).name : ''
    this.user.lastName = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!).lastName : ''

    if(this.profile ===  Profiles.ANALIST){
      this.menu = this._menuBarService.analystMenuBar()
    }
    if(this.profile ===  Profiles.PROVIDER){
      this.menu = this._menuBarService.providerMenuBar()
    }
    if(this.profile ===  Profiles.ADMIN){
      this.menu = this._menuBarService.adminMenuBar()
    }
    this.menuUser = [
      {
          items: [
            {
                label: this.user.name + ' ' + this.user.lastName ,
                icon: 'pi pi-user',
                styleClass: 'non-clickable-item'
            },
            {
              label: 'Cerrar Sesión',
              icon: 'pi pi-sign-out',
              command: ()=> this.logout()
            }
          ]
      }
    ];

    if(localStorage.getItem('company')){
      const company =  JSON.parse(localStorage.getItem('company')!)
      this.primaryColorHexadecimal =`#${company.primaryColorInfo.hexadecimal}`;
      this.secondaryColorHexadecimal =`#${company.secondaryColorInfo.hexadecimal}`;
    } else {
      this.isLoading = true;
      this._dataService.getCompanyData().subscribe({
        next: (response)=> {
          this.primaryColorHexadecimal =`#${response.data.company.primaryColorInfo!.hexadecimal}`;
          this.secondaryColorHexadecimal =`#${response.data.company.secondaryColorInfo!.hexadecimal}`;
          this.dataInfo = response.data.dataInfo;
          this.whatsAppNumber = response.data.dataInfo.find((item: any) => item.typeDataName === DataValues.WHATSAPP)?.dataValue!;
          this.whatsAppMessage = response.data.dataInfo.find((item: any) => item.typeDataName === DataValues.WHATSAPP_MESSAGE)?.dataValue!;
          const companyToSaveLocalStorage = {
            ...response.data.company,
            dataInfo: [...response.data.dataInfo],
            whatsAppNumber: this.whatsAppNumber,
            whatsAppMessage: this.whatsAppMessage
          }
          localStorage.setItem('company', JSON.stringify(companyToSaveLocalStorage));
          this.isLoading = false;
      },
        error: (error)=> {
          console.debug(error)
          throw error;
        }
      })
    }
    if(this.primaryColorHexadecimal !== '' && this.secondaryColorHexadecimal !== ''){
      this.applyTheme(this.primaryColorHexadecimal, this.secondaryColorHexadecimal)
    }

  }

  applyTheme(primary: string, secondary: string) {
    document.documentElement.style.setProperty('--primary-color', primary);
    document.documentElement.style.setProperty('--secondary-color', secondary);
  }

  logout(){
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this._router.navigate(['/'])
  }
}
